import moment from 'moment'

import useStyles from './loggerLastActivated.styles'

type Props = {
    value?: string,
}

const defaultProps: Partial<Props> = {
    value: undefined,
}

const LoggerLastActivated = ({
    value,
}: Props) => {
    const {
        classes,
    } = useStyles()

    return (
        <div
            className={classes.wrapper}
            data-testid="last-activated-div"
        >
            {value && `${moment.utc(value, 'DD.MM.YYYY HH:mm:ss').local().fromNow(true)}`}
        </div>
    )
}

LoggerLastActivated.defaultProps = defaultProps

export default LoggerLastActivated
